const CDN = "https://res.cloudinary.com/dczcnlx82/image/upload/f_auto,q_auto,w_1400";

// Editorial banner — romantic bed-with-a-view shot
const img1 = `${CDN}/To_Time_to_Read_kchpcj.jpg`;
// Staggered pair — deck water view + bright dining
const img2 = "https://res.cloudinary.com/dczcnlx82/image/upload/v1781026113/20260601_153247_rw4ilt.jpg";
const img3 = `${CDN}/sit_and_chill3_nxslbe.jpg`;

export default function ExperienceSection() {

  return (
    <section id="experience" data-testid="experience-section" className="bg-[#FAFAF8]">

      {/* Full-width editorial banner — Plum Guide "breaker" style */}
      <div className="relative h-[55vh] overflow-hidden">
        <img
          src={img1}
          alt="Houseboat interior"
          data-testid="experience-image-1"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#1C1C1A]/40" />
        <div className="absolute inset-0 flex items-center justify-center text-center px-6">
          <div>
            <p className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-white leading-tight">
              You'll never want to<br />
              <em className="italic">stay on land again.</em>
            </p>
          </div>
        </div>
      </div>

      {/* Two-col text + images */}
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 py-24 sm:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">

          {/* Left: text */}
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <p className="eyebrow mb-5">The Experience</p>
            <h2 className="font-serif text-4xl sm:text-5xl font-light text-[#1C1C1A] tracking-tight leading-tight">
              A slower kind<br />
              <em className="italic">of holiday.</em>
            </h2>
            <p className="mt-7 text-[#6B6B65] leading-relaxed font-light">
              Whether you're seeking time to switch off, or just plain old relaxation, the houseboat opens the door to a different pace. Read a book. Have breakfast on the rear deck. Catch the sunset from the roof.
            </p>

            {/* Feature pillars */}
            <div className="mt-12 space-y-6">
              {[
                { t: "Self check-in", b: "Lockbox and marina entry codes shared before arrival." },
                { t: "Free parking", b: "On-site parking alongside the houseboats." },
                { t: "Walk to dinner", b: "The Chalets Restaurant (1km) and Glasson LakeHouse Hotel (1.5km)." },
              ].map((h) => (
                <div key={h.t} className="flex gap-5 items-start">
                  <div className="w-5 h-px bg-[#C8A96E] mt-3 shrink-0" />
                  <div>
                    <p className="font-medium text-[#1C1C1A] text-sm">{h.t}</p>
                    <p className="mt-1 text-sm text-[#6B6B65] leading-relaxed font-light">{h.b}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: staggered image pair */}
          <div className="lg:col-span-7 grid grid-cols-2 gap-5 items-start">
            <div className="img-zoom-wrap mt-12">
              <img
                src={img2}
                alt="Deck"
                data-testid="experience-image-2"
                className="w-full aspect-[3/4] object-cover"
              />
            </div>
            <div className="img-zoom-wrap">
              <img
                src={img3}
                alt="Lounge"
                data-testid="experience-image-3"
                className="w-full aspect-[3/4] object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
